<div *ngIf="devAreaName" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-section form-font-size component-container">
  <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
    <label class="ui-g-5 field-label text-right-align" for="personal-data-dev-area-name">
      {{ 'basic-profile.jurisdiction.development-area-name' | translate }}
    </label>
    <p-dropdown
      *ngIf="isLookupValue"
      [options]="devAreaTypes"
      [(ngModel)]="devAreaName"
      [ngModelOptions]="{ standalone: true }"
      [disabled]="true"
      id="personal-data-dev-area-name"
      placeholder="-Select-">
      <ng-template let-item pTemplate="selectedItem">
        <span class="drop-item-label">{{ 'lookup.' + devAreaKey + '.options.' + item['value'] + '.name' | translate }}</span>
      </ng-template>
      <ng-template let-option pTemplate="item">
        <div class="drop-item">
          <span class="drop-item-label">{{ 'lookup.' + devAreaKey + '.options.' + option['value'] + '.name' | translate }}</span>
        </div>
      </ng-template>
    </p-dropdown>
    <input
      *ngIf="!isLookupValue"
      class="ui-input pInputText"
      id="personal-data-dev-area-name"
      pInputText
      size="30"
      [value]="devAreaName"
      [disabled]="true" />
  </div>
</div>
